import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Advt from './components/Advt/Advt';
import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import { useVote } from './hooks/useVote';
import Vote from './components/Vote/Vote';
import { VoteCounter } from './components/VoteCounter/VoteCounter';

import { useMemo } from 'react';

function App() {
  const { currentMessage, messageAnimationTrigger } = useBroadcast();
  const { isVisible, voteState, voteActivity, currentState, keyRef } =
    useVote();

  const getParams = useGetParams();

  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode1,
    qrCode2,
    qrTitle1,
    qrTitle2,
    voteCounter,
  } = getParams;

  const advt_info = useMemo(
    () => ({
      qrCode1: qrCode1,
      qrCode2: qrCode2,
      qrTitle1: qrTitle1,
      qrTitle2: qrTitle2,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode1, qrCode2, qrTitle1, qrTitle2]
  );

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              }) center/cover no-repeat`
            : 'none',
      }}>
      <CSSTransition
        appear
        in={voteActivity && Boolean(currentState)}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <SwitchTransition>
          <CSSTransition
            key={keyRef}
            classNames="fade-scale"
            timeout={500}
            unmountOnExit>
            <div className="titre-wrapper">
              {!voteState?.variants &&
                (currentState === 'S1' ||
                  currentState === 'S2' ||
                  currentState === 'S3') && (
                  <div
                    className={
                      currentState === 'S1' || currentState === 'S2'
                        ? 'grid-item--xl'
                        : 'grid-item--l'
                    }>
                    <Vote
                      getParams={getParams}
                      advtInfo={advt_info}
                      withCircles={
                        currentState === 'S1' || currentState === 'S2'
                      }
                      withCircleGroup={
                        currentState === 'S1' || currentState === 'S2'
                      }
                      variants={voteState?.vars}
                      title={voteState?.title}
                      withResults={currentState !== 'S1'}
                    />
                  </div>
                )}

              {currentState === 'S1' && voteCounter === '1' && (
                <div className="grid-item--s">
                  <VoteCounter
                    getParams={getParams}
                    total={
                      voteState?.vars.reduce(
                        (acc, el) => acc + Number(el.count),
                        0
                      ) || 0
                    }
                  />
                </div>
              )}

              {(currentState === 'S3' || currentState === 'S4') && (
                <CSSTransition
                  appear
                  in={
                    currentMessage &&
                    (currentState === 'S3' || currentState === 'S4')
                  }
                  timeout={500}
                  classNames="fade-scale"
                  unmountOnExit>
                  <SwitchTransition>
                    <CSSTransition
                      key={messageAnimationTrigger}
                      addEndListener={(node, done) => {
                        node.addEventListener('transitionend', done, false);
                      }}
                      classNames="fade">
                      <Message
                        getParams={getParams}
                        withCircles={currentState === 'S3'}
                        className={
                          currentState === 'S3'
                            ? 'titre-message grid-item--m ml-40'
                            : 'titre-message grid-item--m'
                        }
                        message={currentMessage?.message || {}}
                      />
                    </CSSTransition>
                  </SwitchTransition>
                </CSSTransition>
              )}

              {currentState === 'S4' && (
                <CSSTransition
                  appear
                  in={currentState === 'S4'}
                  timeout={500}
                  classNames="fade-scale"
                  unmountOnExit>
                  <div
                    className={currentMessage?.message ? 'cta' : 'ctaNoMargin'}>
                    <Advt
                      className="titre-advt"
                      advtInfo={advt_info}
                      getParams={getParams}
                    />
                  </div>
                </CSSTransition>
              )}
            </div>
          </CSSTransition>
        </SwitchTransition>
      </CSSTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
